//const Enumerable = require('linq');
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import Annonce from './components/annonce.js'

(function ($, root, undefined) {
	$(function () {
		var app = new Vue({
			el: '#hebergement-app',
			components: {
				'annonce': Annonce,
			},	
			data: {
				hebergements: [],
				o_hebergements: [],
				filtered_hebergements: [],
				dropdown_shown: false,
				sub_shown: false,
				
				filters: {
					regions: [],
					villes: [],
					services: [],
					types: [],
				},
				filters_meta: {
					active: false,
					lonely: false,
					active_count: 0,
					one_region_ville: false,
				},
				pagination: 1,
				search_key: "",
				next_available: false,
				is_search: false,
				is_search_tablet: false,
				search_timeout: false,
				loading: false,
				shown_tax: "",
				app_loaded: false,
				announce_cpt_big: 0,
				announce_cpt_small: 0,
				has_hardcoded_data: false,
				skip_change_hhd: false,
				search_changed: false,
				current_lang: "",
				
			},
			watch: {
				filters : {
					handler(newValue, oldValue) {
						
						this.check_active_filter();
						
						if (!this.skip_change_hhd) {
							this.has_hardcoded_data = false;
						}
					},
					deep: true
				},
				"filters.regions": {
					handler(newValue, oldValue) {
						this.check_tax_desc();
					},
				},
				"filters.villes": {
					handler(newValue, oldValue) {
						this.check_tax_desc();
					},
				},
				hebergements: {
					handler(newValue, oldValue) {
						
						if (this.filtered_hebergements.length > this.hebergements.length ){
							this.next_available = true;
						}else{
							this.next_available = false;
						}
					},
				},
				search_key: {
					handler(newValue, oldValue) {
						if(newValue != oldValue){
							this.search_changed = true;
							
						}
					},
					deep: false
				},
			},
			mounted: function () {
				
				var that = this;
				that.current_lang = that.$refs.current_lang.value;
				if (that.$refs.hardcodeddata){
					that.skip_change_hhd = true;
					
					that.has_hardcoded_data = true;
					let def_filter = that.$refs.def_filter.value;
					let def_filter_value = that.$refs.def_filter_value.value;
					that.filters[def_filter].push(def_filter_value);
					
					that.$nextTick(function () {
						that.skip_change_hhd = false;	
					});
					
				}
				
				let load_remote_data = false;
				
				if (window.performance) {
					 var navEntries = window.performance.getEntriesByType('navigation');
					 if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
						  console.log('As per API lv2, this page is load from back/forward');
					 } else if (window.performance.navigation
						  && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
						  console.log('As per API lv1, this page is load from back/forward');
					 } else {
						  console.log('This is normal page load');
						  load_remote_data = true;
					 }
				} else {
					console.log("Unfortunately, your browser doesn't support this API");
					load_remote_data = true;
				}
				
				
				if  (load_remote_data){
					that.loading = true;
					$.ajax({
						url: adminajax_url,
						type: 'POST',
						dataType: 'json',
						data: {
							action: 'load_hebergements',
						}
					}).done(function(data){
						that.hebergements = [];
						that.o_hebergements = data.data;
						that.check_active_filter();
						that.loading = false;
					});
					that.init_paginator();
					that.app_loaded = true;
				}else{
					that.restoreData();
					that.app_loaded = true;
				}
			},
			methods: {
				isfr(){
					return this.current_lang == "fr";
				},
				storeData(){
					localStorage.filters = JSON.stringify(this.filters);
					localStorage.o_hebergements = JSON.stringify(this.o_hebergements);
					localStorage.search_key = JSON.stringify(this.search_key);
					localStorage.cdata = JSON.stringify({vorona:'manidina'});
				},
				restoreData(){
					this.o_hebergements = JSON.parse(localStorage.getItem('o_hebergements'));
					this.search_key = JSON.parse(localStorage.getItem('search_key'));
					this.filters = JSON.parse(localStorage.getItem('filters'));
					this.check_active_filter();
					this.init_paginator();
				},
								
				setUrlState(){
					let url;
					let jsToSlug = {
						'types': "type-hebergement",
						'services': "service",
						'villes': "ville",
						'regions': "region"
					};
					
					let factive = omitBy(this.filters, isEmpty);
					let f_key = (Object.keys(factive) && Object.keys(factive)[0]) || false;
										
					if (f_key){
						
						url = new URL(window.location.origin + this.get_lang_for_url() + "/" + jsToSlug[f_key] + "/" + factive[f_key]);
					}else{
						url = new URL(window.location.origin + this.get_lang_for_url() + "/hebergements/");
					}
					if(!this.has_hardcoded_data){
						window.history.pushState({}, "", url);
					}
				},
				get_lang_for_url(){
					return this.current_lang == 'fr' ? '' : '/' + this.current_lang;
				},
				get_type_icon(slug){
					return  slug;
					
				},
				search_timed(){
					var that = this;
					if(that.search_timeout){
						clearTimeout(that.search_timeout);
					}
					that.search_timeout = setTimeout(function(){
                         that.search()
					}, 1000);
				},
				
				search_timed_mobile(){
					var that = this;
					if(that.search_timeout){
						clearTimeout(that.search_timeout);
					}
					that.search_timeout = setTimeout(function(){
						if (that.search_key == "" ){
							that.search();
						}
					}, 1000);
				},
				clear_search(){
					this.search_key = "";
					clearTimeout(this.search_timeout);
					this.search();
				},
				search(){
					var that = this;
					if (that.is_search && !that.is_search_tablet){
						that.dropdown_shown = false;
					}
					if (!this.skip_change_hhd) {
						this.has_hardcoded_data = false;
					}
					that.search_changed = false;
					that.hebergements = [];
					that.o_hebergements = [];
					that.filtered_hebergements = [];
					that.loading = true;
					$.ajax({
						url: adminajax_url,
						type: 'POST',
						dataType: 'json',
						data: {
							action: 'search_hebergements',
							key: that.search_key,
						}
					}).done(function(data){
						that.hebergements = [];
						that.o_hebergements = data.data;
						that.check_active_filter();
						that.loading = false;
					});
				},
				show_tablet_search(){
					
					var that = this;
					if (this.is_search_tablet){
						that.is_search = false;
						that.is_search_tablet = false;
						
					}else{
						that.is_search = true;
						that.is_search_tablet = true;
						this.dropdown_shown = false;
						setTimeout(function(){
							that.$refs.search_input.focus();
						}, 400)
					}
				},
				show_mobile_search(){
					var that = this;
					that.is_search = true;
					that.show_dropdown();
				},
				
				show_dropdown(){
					if (this.dropdown_shown){
						if (this.is_search ){
							
							if ( this.search_changed ){
								this.search();
							}
						}
						this.dropdown_shown = false;
					}else{
						this.dropdown_shown = true;
					}
				},
				filter_data(){
					
					var that = this;
					if( !that.filters_meta.active ){
						that.filtered_hebergements = that.o_hebergements;
						that.paginate_data();
						return;
					}
					
					let fil_region =  that.filters.regions.length ? that.o_hebergements.filter(function (h) {
						return that.filters.regions.includes(h.region_slug);
					}) : that.o_hebergements;
					
					let fil_ville = that.filters.villes.length ? fil_region.filter(function (h) {
						return  that.filters.villes.includes(h.ville_slug);
					}) : fil_region;
					
					let fil_service = that.filters.services.length ?  fil_ville.filter(function (h) {
						// OU // let f_service = that.filters.services.length ? that.filters.services.some( svc => h.service.includes(svc) ) : true;
						
						return that.filters.services.every( svc => h.service.includes(svc) );
					}) : fil_ville;
					
					
					let fil_type = that.filters.types.length ?  fil_service.filter(function (h) {
						
						return that.filters.types.every( tp => tp == h.type_hebergement_slug );
						/*
						return that.filters.types.every( function (tp){
							console.log(h);
							
						} );
						*/
					}) : fil_service;						
					
					
					
					that.filtered_hebergements = fil_type;
					that.paginate_data();
					
				},
				paginate_data(){
					var that = this;
					let p_start = (that.pagination - 1) * 12
					let p_end = ((that.pagination - 1) * 12) + 12
					let new_toshow = that.filtered_hebergements.slice(p_start, p_end );
					
					that.hebergements = [...that.hebergements, ...new_toshow];
				},
				show_next(){
					var that = this;
					if( that.next_available ){
						that.pagination++;
						that.paginate_data();
					}
				},
				check_active_filter(){
					this.hebergements = [];
					this.pagination = 1;
					let ln = 
							this.filters.regions.length +
							this.filters.villes.length +
							this.filters.services.length + 
							this.filters.types.length;

								
					if (ln == 1){
						this.filters_meta.lonely = true;
					}else{
						this.filters_meta.lonely = false;
					}
					if (ln > 0){
						this.filters_meta.active = true;
					}else{
						this.filters_meta.active = false;
					}
					
					this.filters_meta.active_count = ln;
					this.filter_data();
					this.setUrlState();
					this.storeData();
				},
				
				hasSvc(svcs, svc){
					svcs = svcs.service;
					if (svcs.includes(svc)){
						return '#333333';
					}else{
						return '#919191';
					}
				},
				
				check_tax_desc(){
					if (
						(this.filters.regions.length == 1 && this.filters.villes.length == 0) || 
						(this.filters.regions.length == 0 && this.filters.villes.length == 1)
						){
							this.filters_meta.one_region_ville = true;
							this.get_tax_descr();
						}else{
							this.filters_meta.one_region_ville = false;
							this.shown_tax = "";
						}
				},
				
				get_tax_descr(){
					var that = this;
					let tax_d_tax = "";
					let tax_slug = "";
					
					
					if(this.filters.regions.length == 1){
						tax_d_tax = "region";
						tax_slug = this.filters.regions[0];
					}else if (this.filters.villes.length == 1){
						tax_d_tax = "ville";
						tax_slug = this.filters.villes[0];
					}
					$.ajax({
						url: adminajax_url,
						type: 'POST',
						dataType: 'json',
						data: {
							action: 'get_tax_descr',
							tax: tax_d_tax,
							slug: tax_slug
						}
					}).done(function(data){
						that.shown_tax = data.data;
					});
				},
				
				hasSvcB(svcs, svc){
					svcs = svcs.service;
					if (svcs.includes(svc)){
						return true;
					}else{
						return false;
					}
					
				},
				getBgImage(url, imgs){
					if (imgs == ''){
						return ''
					}else{
						imgs = imgs.split(",");
						return "background-image: url('" + url + imgs[0] + "'); background-size: cover;";
					}
				},
				clear_filter(f){
					
					switch(f){
						case 'regions':
							this.filters.regions = [];
						break;
						case 'villes':
							this.filters.villes = [];
						break;
						case 'services':
							this.filters.services = [];
						break;
						case 'types':
							this.filters.types = [];
						break;
					}
					
				},
				init_paginator(){
					var that = this;
				
					let _paginator = document.querySelector('#paginator');
					let _paginator_observer = new IntersectionObserver( 
						function([e]){ 
							
							if  (e.intersectionRatio >= .9){
								
								that.show_next()
							}
						},
						{ threshold: [.9, 1] }
						
					);
					if (_paginator_observer){
						_paginator_observer.observe(_paginator);
					}
					
				},
				showSub(submenu){
					this.sub_shown = submenu;
				},
				closeSub(){
					this.sub_shown = false;
				},
			}
		});
	
	});
})(jQuery, this);
/* check */


// WEBPACK FOOTER //
// ./assets/js/hebergements.js